<template>
  <div>
    <a-card>
      <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Año')" prop="year" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-input v-model="filterParams.year">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Mes')" prop="month" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <!--              <a-input v-model="filterParams.month">
                            </a-input>-->
              <a-select v-model="filterParams.month">
                <a-select-option v-for="mes in months_name" :key="mes.value">
                  {{ mes.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Compañia')" prop="company" has-feedback
                               :rules="[{ required: false, message: 'Valor requerido' }]">
              <form-model-dropdown style="width: 100%"
                                   v-model="filterParams.company"
                                   endpoint="company">
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :wrapper-col="{ span: 16 }">
              <a-button type="primary" @click="filtrar">Filtrar</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <br><br>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :parentData="filterParams"
              :actions="false"
              ref="master"
              modalWidth="70%"
              @params="paramsTable"
    >
      <template slot="customButton">
        <a-button v-if="this.$userIsInrol('VerOpcInformeEmpleadoXConceptoNC')"
                  :loading="buttonExcelLoading" style="background-color: rgb(29, 111, 66); color: white"
                  icon="file-excel" @click="exportarExcel()">
          Informe Nómina Cerrada
        </a-button>
      </template>
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DATOS GENERALES" key="1">
        <payroll-personal-info-cer v-if="payrollInfo" :payrollInfo="payrollInfo"></payroll-personal-info-cer>
        <span v-else>Seleccione una nómina para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="DETALLE" key="2">
        <payroll-details-cer v-if="payrollInfo" :payrollInfo="payrollInfo"></payroll-details-cer>
        <span v-else>Seleccione una nómina para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        buttonExcelLoading: false,
        fileNameExcel: 'nomina_cerrada',
        paramsT: {},
        endpointExcel: 'payroll_nomina/downloadExcel',
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'payroll',
          tableSetup: {
            actions: false,
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID compañía', dataIndex: 'id_compania', sorter: true},
              {title: 'Compañía', dataIndex: 'compania_nombre', sorter: true},
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Nombre del concepto', dataIndex: 'nombre_concepto', sorter: true},
              {title: 'Naturaleza', dataIndex: 'naturaleza_concepto', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'tpay', sorter: true},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Valor base', dataIndex: 'base', sorter: true},
              {title: 'Valor', dataIndex: 'ammount_desc', sorter: true},
              {title: 'Valor mda local', dataIndex: 'ammount_l_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Periodo', dataIndex: 'period', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true}
            ]
          }
        },
        filterParams: {
          filter_parent_payroll_cer: true,
          year: parseInt(moment().format('YYYY')),
          month: parseInt(moment().format('MM')),
          company: null
        },
        fiOptionsFilter: {
          'label-col': {span: 6},
          'wrapper-col': {span: 16}
        },
        colSpanFilter: {
          xs: 8,
          md: 6
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      filtrar () {
        if (!this.$isEmpty(this.filterParams.year) || !this.$isEmpty(this.filterParams.month)) {
          this.filterParams = {
            filter_parent_payroll_cer: true,
            year: this.filterParams.year,
            month: this.filterParams.month,
            id_company: this.filterParams.company
          }
        } else {
          this.filterParams = {}
        }
      },
      exportarExcel () {
        this.buttonExcelLoading = true
        this.httpClient.getInstance().get('empleado_x_concepto_nomina_cerrada/downloadExcel', {
          responseType: 'arraybuffer',
          params: {
            year: this.filterParams.year,
            month: this.filterParams.month,
            ...this.paramsT
          }
        })
          .then(response => {
            let fileURL = new Blob([response.data], {type: response.headers['content-type']})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }
            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', 'empleado_x_concepto_nomina_cerrada.xlsx')
            fileLink.click()
            this.buttonExcelLoading = false
            // eslint-disable-next-line no-undef
            Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
          })
          .catch(() => {
            this.buttonExcelLoading = false
            // eslint-disable-next-line no-undef
            Mensajes.error('Error', 'No fue posible descargar el archivo.')
          })
          .then(() => {
            this.buttonExcelLoading = false
          })
      }
    },
    computed: {
      parentData () {
        return this.filterParams
      },
      payrollInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/PayrollNomCer.vue